import { TYPE_DEFINITION } from '../AskedQuestions';
import Box from './Box';

interface IProps {
  qTitle: string;
  className?: string;
  initial?: boolean;
}

const Question: React.FC<IProps> = ({ qTitle, className, initial = false }) => {
  return (
    <div
      className={`col-start-1 col-end-4 sm:text-base text-xs flex justify-start items-center mt-2 ${className}`}
      {...(initial
        ? {
            // 'data-aos-anchor': '#target-container',
            // 'data-aos': 'fade-up-left',
            // 'data-aos-duration': '1250',
          }
        : {})}
    >
      <Box id={TYPE_DEFINITION.QUESTION}>{qTitle}</Box>
      {/*<ChatLogo />*/}
    </div>
  );
};

export default Question;
